import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7223ccb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"text-align":"center"},
  class: "GYONO meisaiCont cwU_1"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  style: {"text-align":"center","position":"relative"},
  class: "CLAIMNO meisaiCont cwU_2"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "CLAIM_DATE meisaiCont cwU_3" }
const _hoisted_6 = { class: "SALESMONTH meisaiCont cwU_4" }
const _hoisted_7 = {
  style: {"text-align":"left"},
  class: "ITEMIZE meisaiCont cwU_4-5 selectBorderNone"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  style: {"text-align":"left"},
  class: "ITEMIZE meisaiCont cwU_5 selectBorderNone"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  style: {"text-align":"left"},
  class: "COURSE meisaiCont cwU_6"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  style: {"text-align":"left"},
  class: "COURSE meisaiCont cwU_6-1 selectBorderNone"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  style: {"text-align":"left"},
  class: "COURSE meisaiCont cwU_6-2"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  style: {"text-align":"left"},
  class: "BREAK_DOWN cwU_7"
}
const _hoisted_21 = {
  style: {"text-align":"left"},
  class: "SALES_CD meisaiCont cwU_8"
}
const _hoisted_22 = {
  class: "SUM meisaiCont cwU_9",
  id: "Sales_SUM_1",
  style: {"position":"relative"}
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-info-circle" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = ["disabled"]
const _hoisted_26 = {
  style: {"text-align":"left"},
  class: "SYOHIZEI_RITU meisaiCont cwU_10 selectBorderNone"
}
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "NYUKIN_YOTEI_DATE meisaiCont cwU_11" }
const _hoisted_30 = { class: "NYUKIN_DATE meisaiCont cwU_12" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = { class: "BIKO meisaiCont cwU_13" }
const _hoisted_33 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mt_dtp = _resolveComponent("Mt_dtp")!
  const _component_Mt_dtp4month = _resolveComponent("Mt_dtp4month")!
  const _component_VTooltip = _resolveComponent("VTooltip")!

  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass(["salesrow", { selectedRow: _ctx.item.isSelect }]),
    onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.selectRow())),
    onFocusout: _cache[26] || (_cache[26] = ($event: any) => (_ctx.calcProfit()))
  }, [
    _createElementVNode("td", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        readonly: "true",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.c_sales_rownum) = $event)),
        disabled: 
          (_ctx.item.isApprovedClaim == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          _ctx.isHolisticlock()
        
      }, null, 8, _hoisted_2), [
        [_vModelText, _ctx.item.c_sales_rownum]
      ])
    ]),
    _createElementVNode("td", _hoisted_3, [
      (
          (_ctx.item.isApprovedClaim == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          _ctx.isHolisticlock()
        )
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: "fal fa-external-link claimLnk",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.linkClaim($event)), ["stop"]))
          }))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.cnvClaimnumTmp) = $event)),
        disabled: 
          (_ctx.item.isApprovedClaim == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          _ctx.isHolisticlock()
        
      }, null, 8, _hoisted_4), [
        [_vModelText, _ctx.item.cnvClaimnumTmp]
      ])
    ]),
    _createElementVNode("td", _hoisted_5, [
      _createVNode(_component_Mt_dtp, {
        contdate: _ctx.item.cnvDateIssue,
        "onUpdate:contdate": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.cnvDateIssue) = $event)),
        holidays: _ctx.mastersData,
        "onUpdate:holidays": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.mastersData) = $event)),
        class: "dtpJyutyuBulk jyutyuTable",
        disabled: 
          (_ctx.item.isApprovedClaim == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          _ctx.isHolisticlock()
        
      }, null, 8, ["contdate", "holidays", "disabled"])
    ]),
    _createElementVNode("td", _hoisted_6, [
      _createVNode(_component_Mt_dtp4month, {
        contdate: _ctx.item.cnvDateMonth,
        "onUpdate:contdate": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.item.cnvDateMonth) = $event)),
        class: "dtpJyutyuBulk jyutyuTable",
        minDate: _ctx.getMinDate(),
        disabledDates: _ctx.getDisabledDates(),
        disabled: 
          (_ctx.item.isApprovedClaim == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          _ctx.isHolisticlock()
        
      }, null, 8, ["contdate", "minDate", "disabledDates", "disabled"])
    ]),
    _createElementVNode("td", _hoisted_7, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.item.c_sales_subject) = $event)),
        disabled: 
          (_ctx.item.isApprovedClaim == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          _ctx.isHolisticlock()
        
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opSubject, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.code,
            key: option.code
          }, _toDisplayString(option.label), 9, _hoisted_9))
        }), 128))
      ], 8, _hoisted_8), [
        [_vModelSelect, _ctx.item.c_sales_subject]
      ])
    ]),
    _createElementVNode("td", _hoisted_10, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.item.c_sales_term) = $event)),
        disabled: 
          (_ctx.item.isApprovedClaim == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          _ctx.isHolisticlock()
        
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opTermItem, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.code,
            key: option.code
          }, _toDisplayString(option.label), 9, _hoisted_12))
        }), 128))
      ], 8, _hoisted_11), [
        [_vModelSelect, _ctx.item.c_sales_term]
      ])
    ]),
    _createElementVNode("td", _hoisted_13, [
      _withDirectives(_createElementVNode("input", {
        type: "button",
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.item.cnvItemName) = $event)),
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectItem())),
        disabled: 
          (_ctx.item.isApprovedClaim == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          _ctx.isHolisticlock()
        
      }, null, 8, _hoisted_14), [
        [_vModelText, _ctx.item.cnvItemName]
      ])
    ]),
    _createElementVNode("td", _hoisted_15, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.item.c_sales_item) = $event)),
        disabled: 
          (_ctx.item.isApprovedClaim == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          _ctx.isHolisticlock()
        
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opSupplyType, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.code,
            key: option.code
          }, _toDisplayString(option.label), 9, _hoisted_17))
        }), 128))
      ], 8, _hoisted_16), [
        [_vModelSelect, _ctx.item.c_sales_item]
      ])
    ]),
    _createElementVNode("td", _hoisted_18, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.item.c_sales_count) = $event)),
        disabled: 
          (_ctx.item.isApprovedClaim == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          _ctx.isHolisticlock()
        
      }, null, 8, _hoisted_19), [
        [_vModelText, _ctx.item.c_sales_count]
      ])
    ]),
    _createElementVNode("td", _hoisted_20, [
      _createVNode(_component_Mt_dtp, {
        contdate: _ctx.item.cnvDateStart,
        "onUpdate:contdate": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.item.cnvDateStart) = $event)),
        holidays: _ctx.mastersData,
        "onUpdate:holidays": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.mastersData) = $event)),
        class: "dtpJyutyuBulk jyutyuTable",
        disabled: 
          (_ctx.item.isApprovedClaim == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          _ctx.isHolisticlock()
        
      }, null, 8, ["contdate", "holidays", "disabled"])
    ]),
    _createElementVNode("td", _hoisted_21, [
      _createVNode(_component_Mt_dtp, {
        contdate: _ctx.item.cnvDateEnd,
        "onUpdate:contdate": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.item.cnvDateEnd) = $event)),
        holidays: _ctx.mastersData,
        "onUpdate:holidays": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.mastersData) = $event)),
        class: "dtpJyutyuBulk jyutyuTable",
        disabled: 
          (_ctx.item.isApprovedClaim == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          _ctx.isHolisticlock()
        
      }, null, 8, ["contdate", "holidays", "disabled"])
    ]),
    _createElementVNode("td", _hoisted_22, [
      (_ctx.item.isMissMatch)
        ? (_openBlock(), _createBlock(_component_VTooltip, {
            key: 0,
            class: "isMissMatchIcon"
          }, {
            popper: _withCtx(() => [
              _createTextVNode(" 請求No" + _toDisplayString(_ctx.item.c_claim_number) + "は、申請中または、承認済みですが、売上明細の合計値と、請求書の合計値が一致していません", 1),
              _hoisted_24,
              _createTextVNode(" 請求No" + _toDisplayString(_ctx.item.c_claim_number) + "の税抜き合計金額は、" + _toDisplayString(_ctx.item.subTotal4Claim!.toLocaleString("ja-JP")) + "円です ", 1)
            ]),
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: _normalizeClass({ isMissMatch: _ctx.item.isMissMatch }),
        maxlength: "10",
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.item.cnvPrice) = $event)),
        onFocus: _cache[17] || (_cache[17] = ($event: any) => (_ctx.kanmaDel($event))),
        onBlur: _cache[18] || (_cache[18] = ($event: any) => (_ctx.kanmaIns($event))),
        disabled: 
          (_ctx.item.isApprovedClaim == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          _ctx.isHolisticlock()
        
      }, null, 42, _hoisted_25), [
        [_vModelText, _ctx.item.cnvPrice]
      ])
    ]),
    _createElementVNode("td", _hoisted_26, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.item.c_sales_taxrate) = $event)),
        disabled: 
          (_ctx.item.isApprovedClaim == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          _ctx.isHolisticlock()
        
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opTaxtate, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.code,
            key: option.code
          }, _toDisplayString(option.label), 9, _hoisted_28))
        }), 128))
      ], 8, _hoisted_27), [
        [_vModelSelect, _ctx.item.c_sales_taxrate]
      ])
    ]),
    _createElementVNode("td", _hoisted_29, [
      _createVNode(_component_Mt_dtp, {
        contdate: _ctx.item.cnvDateExpPayment,
        "onUpdate:contdate": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.item.cnvDateExpPayment) = $event)),
        holidays: _ctx.mastersData,
        "onUpdate:holidays": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.mastersData) = $event)),
        class: "dtpJyutyuBulk jyutyuTable",
        disabled: 
          (_ctx.item.isApprovedClaim == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          _ctx.isHolisticlock()
        
      }, null, 8, ["contdate", "holidays", "disabled"])
    ]),
    _createElementVNode("td", _hoisted_30, [
      (!_ctx.authPayCheck.includes(_ctx.$store.state.id))
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            style: {"font-weight":"normal !important","padding":"6px"},
            disabled: 
            (_ctx.item.isApprovedClaim == 1 &&
              _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
            _ctx.isHolisticlock()
          
          }, _toDisplayString(_ctx.cnvDateFmt(_ctx.item.cnvDateCmpPayment.date)), 9, _hoisted_31))
        : (_openBlock(), _createBlock(_component_Mt_dtp, {
            key: 1,
            contdate: _ctx.item.cnvDateCmpPayment,
            "onUpdate:contdate": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.item.cnvDateCmpPayment) = $event)),
            holidays: _ctx.mastersData,
            "onUpdate:holidays": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.mastersData) = $event)),
            class: "dtpJyutyuBulk jyutyuTable",
            disabled: 
            (_ctx.item.isApprovedClaim == 1 &&
              _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
            _ctx.isHolisticlock()
          
          }, null, 8, ["contdate", "holidays", "disabled"]))
    ]),
    _createElementVNode("td", _hoisted_32, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.item.c_sales_remarks) = $event)),
        disabled: 
          (_ctx.item.isApprovedClaim == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya) ||
          _ctx.isHolisticlock()
        
      }, null, 8, _hoisted_33), [
        [_vModelText, _ctx.item.c_sales_remarks]
      ])
    ])
  ], 34))
}